export const NO_WHITESPACE_STRING_REGEX = /^\S*$/;
export const ANY_WHITESPACE_REGEX = /\s+/g;
export const TWO_FIELDS_SEPARATED_BY_SPACE_OR_HYPHEN_REGEX =
  /^([\S^-]+)([\s-]+)([\S^-]+)$/;
export const TWO_NUMBERS_RANGE_REGEX = /^(\d+)-(\d+)$/; // matches 123-456
export const COMMA_OR_AMPERSTAND_WITH_SPACE_REGEX = /,\s|\s&\s/;
